import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { auth, database } from "../firebase/firebase";
import { ref, push, serverTimestamp } from "firebase/database";
import { onAuthStateChanged } from "firebase/auth";
import { QRCodeSVG } from "qrcode.react";

const plans = [
  { name: "Short", price: 2400 },
  { name: "Short", price: 2900 },
  { name: "Short", price: 3400 },
  { name: "Long", price: 900 },
  { name: "Long", price: 1400 },
  { name: "Long", price: 1900 },
  { name: "Signal", price: 5900 },
  { name: "Signal", price: 7900 },
  { name: "Signal", price: 9900 },
  { name: "Premium", price: 50000 },
];

const Subscribe = () => {
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [btcAmount, setBtcAmount] = useState(0);
  const [user, setUser] = useState(null);
  const navigate = useNavigate();

  const btcAddress = "bc1qseqn945j3kzw8kk6paygatyk8ul07jf9h07vjr";

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      if (!currentUser) {
        navigate("/login");
      } else {
        setUser(currentUser);
      }
    });
    return () => unsubscribe();
  }, [navigate]);

  const handlePlanChange = async (e) => {
    const [name, price] = e.target.value.split("-"); // Extract both name and price
    const selected = plans.find(
      (plan) => plan.name === name && plan.price === parseInt(price, 10)
    );

    setSelectedPlan(selected);

    if (selected) {
      const btcRate = await fetchBtcRate();
      setBtcAmount((selected.price / btcRate).toFixed(8));
    }
  };

  const fetchBtcRate = async () => {
    try {
      const response = await fetch("https://api.coincap.io/v2/assets/bitcoin");
      const data = await response.json();
      return parseFloat(data.data.priceUsd);
    } catch (error) {
      console.error("Error fetching BTC rate:", error);
      return null;
    }
  };

  const handleConfirmPayment = () => {
    if (!selectedPlan || !user) return;

    // Push new deposit
    const depositRef = ref(database, `users/${user.uid}/deposits`);
    push(depositRef, {
      plan: selectedPlan.name,
      usdAmount: selectedPlan.price,
      btcAmount: btcAmount,
      btcAddress: btcAddress,
      status: "Pending",
      date: serverTimestamp(),
    });

    // Add plan to active plans
    const plansRef = ref(database, `users/${user.uid}/plans`);
    push(plansRef, {
      name: selectedPlan.name,
      price: selectedPlan.price,
      startDate: serverTimestamp(),
    });

    navigate("/dashboard");
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-900 text-white p-4">
      <div className="bg-gray-800 p-6 rounded-2xl shadow-xl w-full max-w-md">
        <h2 className="text-2xl font-bold text-center mb-4">
          Subscribe to a Plan
        </h2>
        <select
          className="w-full p-2 bg-gray-700 rounded text-white"
          onChange={handlePlanChange}
          defaultValue=""
        >
          <option value="" disabled>
            Select a Plan
          </option>
          {plans.map((plan) => (
            <option key={plan.price} value={`${plan.name}-${plan.price}`}>
              {plan.name} - ${plan.price}
            </option>
          ))}
        </select>

        {selectedPlan && (
          <div className="mt-4 text-center">
            <p className="mb-2">
              Send exactly <span className="font-bold">{btcAmount} BTC</span>{" "}
              to:
            </p>
            <div className="bg-gray-700 p-3 rounded-lg text-sm break-words">
              {btcAddress}
            </div>
            <div className="mt-4 flex justify-center">
              <QRCodeSVG
                value={btcAddress}
                size={120}
                bgColor="#ffffff"
                fgColor="#000000"
              />
            </div>
            <button
              onClick={handleConfirmPayment}
              className="mt-4 w-full bg-blue-500 hover:bg-blue-600 text-white py-2 rounded-lg transition"
            >
              I Have Paid
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default Subscribe;
